import { render, staticRenderFns } from "./configmgt.vue?vue&type=template&id=5424af2c&scoped=true"
import script from "./configmgt.vue?vue&type=script&lang=js"
export * from "./configmgt.vue?vue&type=script&lang=js"
import style0 from "./configmgt.vue?vue&type=style&index=0&id=5424af2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424af2c",
  null
  
)

export default component.exports